// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"1283e23b","605":"36bc5571","809":"62452d41","981":"0a7ae86c"}[chunkId] + ".chunk.js";
};